var map = {
	"./angular.png": 39,
	"./d3.png": 40,
	"./jenkins.png": 41,
	"./postcss.png": 42,
	"./react.png": 43,
	"./redux.png": 44,
	"./sass.png": 45,
	"./supercharge.png": 46,
	"./ts.png": 47,
	"./webpack.png": 48
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38;